export const ROLES = {
  SUPER_USER: "SUPERUSER",
  ADMIN: "ADMIN",
  USER: "USER",
};
